import { Select } from 'components/select/Select';
import footerStyles from './Footer.module.css';
import { useMemo } from 'react';

export const PageSelect = ({
    onChange,
    pageIndex,
    numberOfPages,
    isDisabled,
}: {
    onChange?: (value: string) => void;
    pageIndex: number;
    numberOfPages: number;
    isDisabled?: boolean;
}) => {
    const pageOptions = useMemo(
        () =>
            Array.from({ length: numberOfPages }, (_, i) => ({
                value: i.toString(),
                label: (i + 1).toString(),
            })),
        [numberOfPages]
    );

    const handleChange = (value: string | null) => {
        if (value !== null && onChange) {
            onChange(value);
        }
    };

    return (
        <Select
            size="xs"
            classNames={{ input: footerStyles.input }}
            onChange={handleChange}
            value={pageIndex.toString()}
            disabled={isDisabled || numberOfPages <= 1}
            data={pageOptions}
            aria-label="Select page"
        />
    );
};
